import React, { useState, useEffect } from 'react';

// Color Constants
const COLORS = {
  gold: '#D4B07A',
  darkBrown: '#391C0B',
  cream: '#F5F1ED',
  offWhite: '#FAFAF8',
};

const ADMIN_WHATSAPP = '923001234567'; // Replace with actual admin WhatsApp number

// Base Oil Options
const BASE_OILS = [
  {
    id: 'goat-milk',
    name: "Goat's Milk",
    description: 'Creamy, nourishing. Perfect for sensitive skin.',
    price: 600,
  },
  {
    id: 'glycerin',
    name: 'Transparent Glycerin',
    description: 'Crystal-clear, moisturizing. Ideal for all skin types.',
    price: 550,
  },
  {
    id: 'shea-butter',
    name: 'Shea Butter',
    description: 'Rich, luxurious. Best for dry skin.',
    price: 700,
  },
];

// Scent Options
const SCENTS = [
  {
    id: 'lavender',
    name: 'Lavender',
    description: 'Calming & relaxing aromatherapy',
    price: 100,
  },
  {
    id: 'sandalwood',
    name: 'Sandalwood',
    description: 'Warm, woody, luxurious',
    price: 120,
  },
  {
    id: 'citrus',
    name: 'Citrus',
    description: 'Fresh, energizing, uplifting',
    price: 80,
  },
  {
    id: 'unscented',
    name: 'Unscented',
    description: 'Pure & simple, perfect for sensitive noses',
    price: 0,
  },
];

// Additive Options
const ADDITIVES = [
  {
    id: 'charcoal',
    name: 'Activated Charcoal',
    description: 'Exfoliating & detoxifying',
    price: 50,
  },
  {
    id: 'clay',
    name: 'French Pink Clay',
    description: 'Gentle & mineral-rich',
    price: 60,
  },
  {
    id: 'rose-petals',
    name: 'Dried Rose Petals',
    description: 'Aesthetic & calming',
    price: 40,
  },
  {
    id: 'none',
    name: 'None',
    description: 'Classic & pure',
    price: 0,
  },
];

// Signature Soaps
const SIGNATURE_SOAPS = [
  {
    id: 1,
    name: 'Charcoal & Mint',
    description: 'Detoxifying & refreshing blend for deep cleansing',
    emoji: '🖤',
    price: 850,
  },
  {
    id: 2,
    name: 'Honey & Oats',
    description: 'Nourishing & gentle exfoliation for sensitive skin',
    emoji: '✨',
    price: 900,
  },
  {
    id: 3,
    name: 'Lavender Dream',
    description: 'Calming & aromatherapeutic luxury soap',
    emoji: '💜',
    price: 900,
  },
];

// Navigation Bar Component
const Navigation = ({ onBuildClick, mobileMenuOpen, setMobileMenuOpen }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white bg-opacity-95 backdrop-blur-md shadow-lg'
          : 'bg-white bg-opacity-95 backdrop-blur-md'
      }`}
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1
              className="text-2xl font-bold"
              style={{ color: COLORS.darkBrown, fontFamily: "'Playfair Display', serif" }}
            >
              Saponifié
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#home" className="underline-animation" style={{ color: COLORS.darkBrown }}>
              Home
            </a>
            <a href="#about" className="underline-animation" style={{ color: COLORS.darkBrown }}>
              About
            </a>
            <a href="#soaps" className="underline-animation" style={{ color: COLORS.darkBrown }}>
              Soaps
            </a>
            <button
              onClick={onBuildClick}
              className="px-6 py-2 rounded-full font-semibold transition-all duration-300 hover:shadow-lg"
              style={{
                backgroundColor: COLORS.gold,
                color: COLORS.darkBrown,
              }}
            >
              Build Your Bar
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md transition-colors"
              style={{ color: COLORS.darkBrown }}
              aria-label="Toggle menu"
            >
              <svg
                className={`h-6 w-6 transition-transform duration-300 ${
                  mobileMenuOpen ? 'rotate-90' : ''
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={mobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 animate-slideDown" style={{ backgroundColor: COLORS.cream }}>
            <a
              href="#home"
              className="block px-3 py-2 rounded-md text-base font-medium"
              style={{ color: COLORS.darkBrown }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </a>
            <a
              href="#about"
              className="block px-3 py-2 rounded-md text-base font-medium"
              style={{ color: COLORS.darkBrown }}
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              href="#soaps"
              className="block px-3 py-2 rounded-md text-base font-medium"
              style={{ color: COLORS.darkBrown }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Soaps
            </a>
            <button
              onClick={() => {
                onBuildClick();
                setMobileMenuOpen(false);
              }}
              className="w-full mt-2 px-6 py-2 rounded-full font-semibold transition-all duration-300"
              style={{
                backgroundColor: COLORS.gold,
                color: COLORS.darkBrown,
              }}
            >
              Build Your Bar
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

// Hero Section Component
const HeroSection = ({ onBuildClick }) => {
  return (
    <div
      id="home"
      className="min-h-screen flex items-center justify-center px-4 py-20 relative overflow-hidden"
      style={{ backgroundColor: COLORS.offWhite }}
    >
      {/* Floating gradient blob */}
      <div
        className="absolute top-20 right-10 w-96 h-96 rounded-full opacity-20 animate-float blur-3xl"
        style={{
          background: `linear-gradient(135deg, ${COLORS.gold} 0%, ${COLORS.cream} 100%)`,
        }}
      ></div>

      <div className="max-w-4xl mx-auto text-center relative z-10 animate-fadeInUp">
        <h1
          className="text-5xl md:text-6xl font-bold leading-tight mb-6"
          style={{
            color: COLORS.darkBrown,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          Bespoke Skincare,{'\n'}Saponified for You
        </h1>

        <p
          className="text-xl md:text-2xl font-light mb-8"
          style={{ color: COLORS.darkBrown, opacity: 0.7 }}
        >
          Handcrafted, Chemical-Free, Personalized to Perfection
        </p>

        <button
          onClick={onBuildClick}
          className="px-12 py-3 rounded-full font-semibold text-lg transition-all duration-300 hover:-translate-y-1 shadow-lg hover:shadow-2xl"
          style={{
            backgroundColor: COLORS.gold,
            color: COLORS.darkBrown,
          }}
        >
          Build Your Custom Bar
        </button>
      </div>
    </div>
  );
};

// About Section Component
const AboutSection = () => {
  const features = [
    '100% Chemical-Free',
    'Handcrafted in Small Batches',
    'Fully Customizable',
    'Premium Natural Ingredients',
  ];

  return (
    <section
      id="about"
      className="py-16 md:py-24 px-4"
      style={{ backgroundColor: COLORS.offWhite }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
          {/* Left Column - Image */}
          <div
            className="h-96 rounded-3xl flex items-center justify-center animate-fadeIn"
            style={{
              background: `linear-gradient(135deg, ${COLORS.gold} 0%, ${COLORS.cream} 100%)`,
            }}
          >
            <div className="text-9xl animate-pulse">🧼</div>
          </div>

          {/* Right Column - Content */}
          <div className="animate-fadeInUp">
            <h2
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{
                color: COLORS.darkBrown,
                fontFamily: "'Playfair Display', serif",
              }}
            >
              Why Saponifié?
            </h2>

            <p
              className="text-lg mb-4 leading-relaxed"
              style={{ color: COLORS.darkBrown, opacity: 0.8 }}
            >
              We believe luxury should be intentional. Every bar is handcrafted using 100% natural base oils, zero synthetic chemicals, and your personalized blend of scent and exfoliants.
            </p>

            <p
              className="text-lg mb-8 leading-relaxed"
              style={{ color: COLORS.darkBrown, opacity: 0.8 }}
            >
              Whether a gift or a self-care ritual, your custom soap is uniquely yours.
            </p>

            <ul className="space-y-3">
              {features.map((feature, idx) => (
                <li
                  key={idx}
                  className="text-lg flex items-center"
                  style={{ color: COLORS.darkBrown }}
                >
                  <span
                    className="mr-4 font-bold"
                    style={{ color: COLORS.gold }}
                  >
                    ✓
                  </span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

// Soap Card Component
const SoapCard = ({ soap, onCustomize }) => {
  return (
    <div
      className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 animate-scaleIn"
      style={{
        boxShadow: '0 5px 20px rgba(57, 28, 11, 0.08)',
      }}
    >
      {/* Image Area */}
      <div
        className="h-48 flex items-center justify-center text-8xl animate-pulse"
        style={{
          background: `linear-gradient(135deg, ${COLORS.gold} 0%, ${COLORS.cream} 100%)`,
        }}
      >
        {soap.emoji}
      </div>

      {/* Info Section */}
      <div className="p-6">
        <h3
          className="text-2xl font-semibold mb-2"
          style={{
            color: COLORS.darkBrown,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          {soap.name}
        </h3>

        <p
          className="text-base mb-4 truncate"
          style={{ color: COLORS.darkBrown, opacity: 0.6 }}
        >
          {soap.description}
        </p>

        <div className="flex justify-between items-center mb-4">
          <span
            className="text-2xl font-bold"
            style={{ color: COLORS.gold }}
          >
            Rs. {soap.price}
          </span>
        </div>

        <button
          onClick={() => onCustomize(soap)}
          className="w-full py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg"
          style={{
            backgroundColor: COLORS.darkBrown,
            color: 'white',
          }}
        >
          Customize
        </button>
      </div>
    </div>
  );
};

// Featured Soaps Section
const SoapsSection = ({ onCustomizeSoap }) => {
  return (
    <section
      id="soaps"
      className="py-16 md:py-24 px-4"
      style={{ backgroundColor: COLORS.offWhite }}
    >
      <div className="max-w-7xl mx-auto">
        <h2
          className="text-4xl md:text-5xl font-bold text-center mb-16"
          style={{
            color: COLORS.darkBrown,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          Signature Blends
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {SIGNATURE_SOAPS.map((soap) => (
            <SoapCard
              key={soap.id}
              soap={soap}
              onCustomize={onCustomizeSoap}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// Selection Card Component for Builder
const SelectionCard = ({ option, isSelected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="p-6 rounded-2xl cursor-pointer transition-all duration-300 border-2"
      style={{
        backgroundColor: isSelected
          ? `rgba(212, 176, 122, 0.3)`
          : `rgba(212, 176, 122, 0.1)`,
        borderColor: isSelected ? COLORS.gold : `rgba(212, 176, 122, 0.3)`,
        transform: isSelected ? 'translateX(10px)' : 'translateX(0)',
      }}
    >
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h4 className="text-xl font-semibold mb-2 text-white">
            {option.name}
          </h4>
          <p className="text-white opacity-70 text-sm">
            {option.description}
          </p>
        </div>
        <div
          className="text-2xl font-bold ml-4"
          style={{ color: COLORS.gold }}
        >
          {option.price === 0 ? 'Free' : `Rs. ${option.price}`}
        </div>
      </div>
    </div>
  );
};

// Progress Bar Component
const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full h-1 bg-white bg-opacity-20 rounded-full mb-12">
      <div
        className="h-full rounded-full transition-all duration-500"
        style={{
          backgroundColor: COLORS.gold,
          width: `${progress}%`,
        }}
      ></div>
    </div>
  );
};

// Step Title Component
const StepTitle = ({ title, description }) => {
  return (
    <div className="mb-8">
      <h2
        className="text-4xl md:text-5xl font-bold mb-4"
        style={{
          color: COLORS.gold,
          fontFamily: "'Playfair Display', serif",
        }}
      >
        {title}
      </h2>
      <p className="text-xl" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
        {description}
      </p>
    </div>
  );
};

// Custom Builder Component
const CustomBuilder = ({
  showBuilder,
  onClose,
  onOrderComplete,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedBase, setSelectedBase] = useState(null);
  const [selectedScent, setSelectedScent] = useState(null);
  const [selectedAdditive, setSelectedAdditive] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    whatsapp: '',
    address: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const calculateTotal = () => {
    let total = 0;
    if (selectedBase) total += selectedBase.price;
    if (selectedScent) total += selectedScent.price;
    if (selectedAdditive) total += selectedAdditive.price;
    return total;
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    // Clear error for this field when user starts typing
    if (formErrors[field]) {
      setFormErrors({ ...formErrors, [field]: '' });
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name || formData.name.trim().length < 2) {
      errors.name = 'Please enter a valid name (at least 2 characters)';
    }

    if (
      !formData.whatsapp ||
      formData.whatsapp.replace(/\D/g, '').length < 10
    ) {
      errors.whatsapp = 'Please enter a valid WhatsApp number (at least 10 digits)';
    }

    if (!formData.address || formData.address.trim().length < 10) {
      errors.address = 'Please enter a valid delivery address (at least 10 characters)';
    }

    return { isValid: Object.keys(errors).length === 0, errors };
  };

  const generateWhatsAppMessage = () => {
    const baseName = selectedBase?.name || 'Not selected';
    const scentName = selectedScent?.name || 'Not selected';
    const additiveName = selectedAdditive?.name || 'None';
    const totalPrice = calculateTotal();

    return `Hi Saponifié! 👋

I would like to order a custom soap bar.

📦 My Custom Bar:
• Base Oil: ${baseName}
• Scent: ${scentName}
• Additive: ${additiveName}
• Total Price: Rs. ${totalPrice}

🚚 Delivery Details:
• Name: ${formData.name}
• WhatsApp: ${formData.whatsapp}
• Address: ${formData.address}

Looking forward to my order! ✨`;
  };

  const handlePlaceOrder = () => {
    const { isValid, errors } = validateForm();

    if (!isValid) {
      setFormErrors(errors);
      return;
    }

    const message = generateWhatsAppMessage();
    const whatsappLink = `https://wa.me/${ADMIN_WHATSAPP}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappLink, '_blank');

    // Show success modal
    setShowSuccessModal(true);
  };

  const handleBuildAnother = () => {
    setShowSuccessModal(false);
    setCurrentStep(1);
    setSelectedBase(null);
    setSelectedScent(null);
    setSelectedAdditive(null);
    setFormData({ name: '', whatsapp: '', address: '' });
    setFormErrors({});
    onClose();
  };

  if (!showBuilder) return null;

  return (
    <div
      className="fixed inset-0 overflow-y-auto"
      style={{ backgroundColor: COLORS.darkBrown, zIndex: 40 }}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="fixed top-6 right-6 z-50 p-2 rounded-full transition-all duration-300 hover:bg-opacity-20"
        style={{ backgroundColor: 'rgba(212, 176, 122, 0.3)' }}
        aria-label="Close builder"
      >
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="min-h-screen p-6 md:p-12">
        <div className="max-w-3xl mx-auto">
          {/* Progress Bar */}
          <ProgressBar currentStep={currentStep} totalSteps={4} />

          {/* Step 1: Base Oil Selection */}
          {currentStep === 1 && (
            <div className="animate-fadeInUp">
              <StepTitle
                title="Select Your Base Oil"
                description="The foundation of your luxe soap. Choose based on your skin type and preferences."
              />

              <div className="space-y-4 mb-8">
                {BASE_OILS.map((oil) => (
                  <SelectionCard
                    key={oil.id}
                    option={oil}
                    isSelected={selectedBase?.id === oil.id}
                    onClick={() => setSelectedBase(oil)}
                  />
                ))}
              </div>

              <div className="flex justify-between">
                <div></div>
                <button
                  onClick={() => {
                    if (selectedBase) setCurrentStep(2);
                  }}
                  disabled={!selectedBase}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300 disabled:opacity-50"
                  style={{
                    backgroundColor: selectedBase ? COLORS.gold : 'rgba(212, 176, 122, 0.3)',
                    color: COLORS.darkBrown,
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Step 2: Scent Selection */}
          {currentStep === 2 && (
            <div className="animate-fadeInUp">
              <StepTitle
                title="Select Your Signature Scent"
                description="Pick a fragrance that resonates with you."
              />

              <div className="space-y-4 mb-8">
                {SCENTS.map((scent) => (
                  <SelectionCard
                    key={scent.id}
                    option={scent}
                    isSelected={selectedScent?.id === scent.id}
                    onClick={() => setSelectedScent(scent)}
                  />
                ))}
              </div>

              <div className="flex justify-between">
                <button
                  onClick={() => setCurrentStep(1)}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                  style={{
                    backgroundColor: 'rgba(212, 176, 122, 0.3)',
                    color: 'white',
                  }}
                >
                  Back
                </button>
                <button
                  onClick={() => {
                    if (selectedScent) setCurrentStep(3);
                  }}
                  disabled={!selectedScent}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300 disabled:opacity-50"
                  style={{
                    backgroundColor: selectedScent ? COLORS.gold : 'rgba(212, 176, 122, 0.3)',
                    color: COLORS.darkBrown,
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Additive Selection */}
          {currentStep === 3 && (
            <div className="animate-fadeInUp">
              <StepTitle
                title="Add an Exfoliant (Optional)"
                description="Customize with texture, visual appeal, or extra benefits."
              />

              <div className="space-y-4 mb-8">
                {ADDITIVES.map((additive) => (
                  <SelectionCard
                    key={additive.id}
                    option={additive}
                    isSelected={selectedAdditive?.id === additive.id}
                    onClick={() => setSelectedAdditive(additive)}
                  />
                ))}
              </div>

              <div className="flex justify-between">
                <button
                  onClick={() => setCurrentStep(2)}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                  style={{
                    backgroundColor: 'rgba(212, 176, 122, 0.3)',
                    color: 'white',
                  }}
                >
                  Back
                </button>
                <button
                  onClick={() => setCurrentStep(4)}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                  style={{
                    backgroundColor: COLORS.gold,
                    color: COLORS.darkBrown,
                  }}
                >
                  Review Order
                </button>
              </div>
            </div>
          )}

          {/* Step 4: Review & Checkout */}
          {currentStep === 4 && (
            <div className="animate-fadeInUp">
              <StepTitle
                title="Your Custom Bar"
                description="Review your selections and provide delivery details."
              />

              {/* Order Summary */}
              <div
                className="p-8 rounded-2xl mb-8 border-2"
                style={{
                  backgroundColor: 'rgba(212, 176, 122, 0.15)',
                  borderColor: COLORS.gold,
                }}
              >
                <div className="space-y-4 mb-6 pb-6" style={{ borderBottom: `2px solid ${COLORS.gold}` }}>
                  <div className="flex justify-between">
                    <span className="text-white">Base Oil:</span>
                    <span className="text-white font-semibold">{selectedBase?.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-white">Scent:</span>
                    <span className="text-white font-semibold">{selectedScent?.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-white">Additive:</span>
                    <span className="text-white font-semibold">{selectedAdditive?.name}</span>
                  </div>
                </div>

                <div className="flex justify-between pt-6">
                  <span className="text-white text-lg">Total Price:</span>
                  <span
                    className="text-3xl font-bold"
                    style={{ color: COLORS.gold }}
                  >
                    Rs. {calculateTotal()}
                  </span>
                </div>
              </div>

              {/* Form */}
              <div className="space-y-6 mb-8">
                {/* Name Input */}
                <div>
                  <label
                    className="block text-lg font-semibold mb-2"
                    style={{ color: COLORS.gold }}
                  >
                    Full Name *
                  </label>
                  <input
                    type="text"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    className="w-full px-4 py-3 rounded-lg bg-opacity-10 text-white placeholder-gray-400 focus:outline-none focus:ring-2 transition-all"
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderColor: formErrors.name ? '#E74C3C' : `rgba(212, 176, 122, 0.3)`,
                      border: formErrors.name ? '2px solid #E74C3C' : '2px solid rgba(212, 176, 122, 0.3)',
                      boxShadow: formErrors.name ? 'none' : 'none',
                    }}
                  />
                  {formErrors.name && (
                    <p className="text-red-400 text-sm mt-2">{formErrors.name}</p>
                  )}
                </div>

                {/* WhatsApp Input */}
                <div>
                  <label
                    className="block text-lg font-semibold mb-2"
                    style={{ color: COLORS.gold }}
                  >
                    WhatsApp Number *
                  </label>
                  <input
                    type="tel"
                    placeholder="03001234567 or +92-300-1234567"
                    value={formData.whatsapp}
                    onChange={(e) => handleInputChange('whatsapp', e.target.value)}
                    className="w-full px-4 py-3 rounded-lg bg-opacity-10 text-white placeholder-gray-400 focus:outline-none focus:ring-2 transition-all"
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderColor: formErrors.whatsapp ? '#E74C3C' : `rgba(212, 176, 122, 0.3)`,
                      border: formErrors.whatsapp ? '2px solid #E74C3C' : '2px solid rgba(212, 176, 122, 0.3)',
                    }}
                  />
                  {formErrors.whatsapp && (
                    <p className="text-red-400 text-sm mt-2">{formErrors.whatsapp}</p>
                  )}
                </div>

                {/* Address Textarea */}
                <div>
                  <label
                    className="block text-lg font-semibold mb-2"
                    style={{ color: COLORS.gold }}
                  >
                    Delivery Address *
                  </label>
                  <textarea
                    placeholder="House No., Street, City, Area Code"
                    value={formData.address}
                    onChange={(e) => handleInputChange('address', e.target.value)}
                    rows={3}
                    className="w-full px-4 py-3 rounded-lg bg-opacity-10 text-white placeholder-gray-400 focus:outline-none focus:ring-2 transition-all resize-none"
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderColor: formErrors.address ? '#E74C3C' : `rgba(212, 176, 122, 0.3)`,
                      border: formErrors.address ? '2px solid #E74C3C' : '2px solid rgba(212, 176, 122, 0.3)',
                    }}
                  />
                  {formErrors.address && (
                    <p className="text-red-400 text-sm mt-2">{formErrors.address}</p>
                  )}
                </div>
              </div>

              <div className="flex justify-between">
                <button
                  onClick={() => setCurrentStep(3)}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                  style={{
                    backgroundColor: 'rgba(212, 176, 122, 0.3)',
                    color: 'white',
                  }}
                >
                  Back
                </button>
                <button
                  onClick={handlePlaceOrder}
                  className="px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg"
                  style={{
                    backgroundColor: COLORS.gold,
                    color: COLORS.darkBrown,
                  }}
                >
                  Place Order via WhatsApp
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="fixed inset-0 flex items-center justify-center p-4 animate-fadeIn"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 50,
          }}
        >
          <div
            className="bg-white rounded-3xl p-8 md:p-12 max-w-md w-full text-center animate-slideUp"
          >
            <div
              className="text-6xl mb-6 animate-checkAnimation"
              style={{ color: COLORS.gold }}
            >
              ✓
            </div>

            <h3
              className="text-3xl font-bold mb-4"
              style={{
                color: COLORS.darkBrown,
                fontFamily: "'Playfair Display', serif",
              }}
            >
              Order Sent!
            </h3>

            <p
              className="text-base mb-8"
              style={{ color: COLORS.darkBrown, opacity: 0.7 }}
            >
              Your custom soap order has been sent to our WhatsApp. We'll confirm shortly and get crafting your perfect bar!
            </p>

            <button
              onClick={handleBuildAnother}
              className="w-full px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg"
              style={{
                backgroundColor: COLORS.gold,
                color: COLORS.darkBrown,
              }}
            >
              Build Another
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer
      className="py-8 text-center"
      style={{ backgroundColor: COLORS.darkBrown }}
    >
      <p className="text-white mb-2">
        © 2024 Saponifié. Handcrafted with love. ✨
      </p>
      <p className="text-white opacity-80">
        Questions? Reach us on WhatsApp!
      </p>
    </footer>
  );
};

// Main App Component
export default function App() {
  const [showBuilder, setShowBuilder] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleBuildClick = () => {
    setShowBuilder(true);
    setMobileMenuOpen(false);
  };

  const handleCloseBuilder = () => {
    setShowBuilder(false);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: COLORS.offWhite }}>
      <Navigation
        onBuildClick={handleBuildClick}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      {!showBuilder && (
        <>
          <HeroSection onBuildClick={handleBuildClick} />
          <AboutSection />
          <SoapsSection onCustomizeSoap={(soap) => handleBuildClick()} />
          <Footer />
        </>
      )}

      <CustomBuilder
        showBuilder={showBuilder}
        onClose={handleCloseBuilder}
        onOrderComplete={() => {}}
      />
    </div>
  );
}
